import { addToEndOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    getSearchDataModeActive,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    SetExpandTokens,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { dispatchProductImpressions } from "@store/Services/AnalyticsService";

const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
}

replaceInChain(chain, SetExpandTokens, props => {
    props.expandTokens = ["attributes", "facets", "documents"]; // Store Custom Code

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
});

addToEndOfChain(chain, props => {
    const state = props.getState();
    const currency = state.context.session.currency?.currencyCode;
    const { isSearch } = props.parameter;
    const { products } = props.result;
    let page = pageType.productListPage;

    if (isSearch) {
        page = pageType.searchPage;
    }
    if (products && products?.length > 0) {
        dispatchProductImpressions(products, currency, page);
    }
});
